import { useCallback, useEffect } from 'react';
import { AnalyticsEvent, AnalyticsEventProperties } from 'core/analytics/entities';
import { useServices } from 'core/common/hooks';

type Params = Partial<{
  baseEventProperties: AnalyticsEventProperties;
}>;

export const useAnalytics = (analytics?: Partial<AnalyticsEvent>, params?: Params) => {
  const { analyticsService } = useServices();

  const trackClickEvent = (properties?: AnalyticsEventProperties) => {
    if (!analytics?.clickEvent) {
      return;
    }

    analyticsService.trackEvent(analytics.clickEvent, properties);
  };

  const trackSkipEvent = (properties?: AnalyticsEventProperties) => {
    if (!analytics?.skipEvent) return;

    analyticsService.trackEvent(analytics.skipEvent, properties);
  };

  const trackGetOfferEvent = (properties?: AnalyticsEventProperties) => {
    if (!analytics?.getOfferEvent) return;

    analyticsService.trackEvent(analytics.getOfferEvent, properties);
  };

  const trackCustomEvent = (name: string, properties?: AnalyticsEventProperties) => {
    analyticsService.trackEvent(name, properties);
  };

  const updateUserProperties = useCallback(
    (properties: AnalyticsEventProperties) => {
      analyticsService.updateUserProperties(properties);
    },
    [analyticsService],
  );

  useEffect(() => {
    if (!analytics?.baseEvent) return;

    analyticsService.trackEvent(analytics.baseEvent, params?.baseEventProperties);
  }, [analyticsService, analytics, params]);

  return {
    trackClickEvent,
    trackSkipEvent,
    trackGetOfferEvent,
    trackCustomEvent,
    updateUserProperties,
  };
};
